import "core-js/modules/es.number.constructor.js";
import React, { createContext, useContext } from 'react';
import getHelixUIMode, { isHelixAdminViewer } from './getHelixUIMode';
import getViewerScoreBand from './getViewerScoreBand';
import { jsx as _jsx } from "react/jsx-runtime";
var HelixAdminViewContext = /*#__PURE__*/createContext(false);

/*
 * Shows the Helix analysis below it in the view the API sends it in (see isHelixAdminView there).
 * Someone's analysis opened by user id - from the People or My Teams pages, which pass it even
 * for your own - is in the admin view for admins and super users. Your own Profile pages pass no
 * user id, so they're always in the user view, and admins see what their people see.
 */
export function HelixAdminViewProvider(_ref) {
  var userId = _ref.userId,
    children = _ref.children;
  var isAdminView = Boolean(Number(userId)) && isHelixAdminViewer();
  return /*#__PURE__*/_jsx(HelixAdminViewContext.Provider, {
    value: isAdminView,
    children: children
  });
}
export function useIsHelixAdminView() {
  return useContext(HelixAdminViewContext);
}
export function useHelixUIMode() {
  return getHelixUIMode({
    isAdminView: useIsHelixAdminView()
  });
}
export function useViewerScoreBand(score) {
  return getViewerScoreBand(score, useHelixUIMode());
}